import React from 'react'
import styled from 'styled-components'
import Image from 'next/legacy/image'
import { Row } from 'components/common/layout'
import { MyLink } from 'components/common/link'
import { BaseText } from 'components/common/text'
import { useRouter } from 'next/router'
import { IS_MAIN_PROD } from 'infra/constants'

const ADMIN_BASE_PATH = '/admin'

export const AdminHeader = () => {
  const router = useRouter()
  return (
    <Container>
      <MyLink href={ADMIN_BASE_PATH}>
        <div style={{ width: 80, height: 20 }}>
          <Image
            src='/admin.svg'
            width={80}
            height={20}
            alt='admin page logo'
          />
        </div>
      </MyLink>
      <MenuBar>
        <MyLink href={`${ADMIN_BASE_PATH}/tracking-hire-beta`}>
          <MenuText
            isSelected={router.pathname.includes(
              `${ADMIN_BASE_PATH}/tracking-hire-beta`,
            )}
          >
            채용 추적 Beta
          </MenuText>
        </MyLink>
        <MenuText>|</MenuText>
        <MyLink href={`/recommend`} newTab>
          <MenuText isSelected={false}>인재 추천</MenuText>
        </MyLink>
        <MyLink href={`${ADMIN_BASE_PATH}/broking-request`}>
          <MenuText
            isSelected={
              router.pathname === `${ADMIN_BASE_PATH}/broking-request` ||
              router.pathname === `${ADMIN_BASE_PATH}/broking-request/confirmed`
            }
          >
            연결 요청
          </MenuText>
        </MyLink>
        <MyLink href={`/pre-interviews`} newTab>
          <MenuText isSelected={false}>대신 미팅</MenuText>
        </MyLink>
        <MyLink href={`${ADMIN_BASE_PATH}/startup-ads`}>
          <MenuText
            isSelected={router.pathname === `${ADMIN_BASE_PATH}/startup-ads`}
          >
            상단 광고
          </MenuText>
        </MyLink>
        <MyLink href={`${ADMIN_BASE_PATH}/tracking-hire`}>
          <MenuText
            isSelected={router.pathname === `${ADMIN_BASE_PATH}/tracking-hire`}
          >
            채용 추적
          </MenuText>
        </MyLink>
        <MyLink href={`${ADMIN_BASE_PATH}/hire-status`}>
          <MenuText
            isSelected={router.pathname === `${ADMIN_BASE_PATH}/hire-status`}
          >
            채용 현황
          </MenuText>
        </MyLink>
        <MenuText>|</MenuText>
        <MyLink href={ADMIN_BASE_PATH}>
          <MenuText isSelected={router.pathname === ADMIN_BASE_PATH}>
            기업 관리
          </MenuText>
        </MyLink>
        <MyLink href={`${ADMIN_BASE_PATH}/users`}>
          <MenuText isSelected={router.pathname === `${ADMIN_BASE_PATH}/users`}>
            인재 관리
          </MenuText>
        </MyLink>
        <MyLink href={`${ADMIN_BASE_PATH}/analytics`}>
          <MenuText
            isSelected={router.pathname === `${ADMIN_BASE_PATH}/analytics`}
          >
            기업 전환
          </MenuText>
        </MyLink>
        <MyLink href={`${ADMIN_BASE_PATH}/active-hire-needs`}>
          <MenuText
            isSelected={
              router.pathname === `${ADMIN_BASE_PATH}/active-hire-needs`
            }
          >
            채용 니즈
          </MenuText>
        </MyLink>
        <MenuText>|</MenuText>
        <MyLink href={`/file-anonymization`} newTab>
          <MenuText isSelected={false}>첨부 파일 익명화</MenuText>
        </MyLink>
        <MyLink href={`${ADMIN_BASE_PATH}/certificate-badge`}>
          <MenuText
            isSelected={
              router.pathname === `${ADMIN_BASE_PATH}/certificate-badge`
            }
          >
            인재 배지 관리
          </MenuText>
        </MyLink>
        {!IS_MAIN_PROD && (
          <>
            <MenuText>|</MenuText>
            <MyLink href={`${ADMIN_BASE_PATH}/create-account`}>
              <MenuText
                isSelected={
                  router.pathname === `${ADMIN_BASE_PATH}/create-account`
                }
              >
                테스트 계정 관리
              </MenuText>
            </MyLink>
          </>
        )}
      </MenuBar>
    </Container>
  )
}

const Container = styled(Row)`
  z-index: 6;
  position: sticky;
  top: 0;
  padding-left: 40px;
  gap: 24px;
  background-color: ${(p) => p.theme.color.white1};
`

const MenuBar = styled(Row)`
  gap: 20px;
  padding: 16px;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`

const MenuText = styled(BaseText)<{ isSelected?: boolean }>`
  white-space: nowrap;
  font-weight: ${(p) => p.theme.fontWeight.medium};
  color: ${(p) => p.theme.color.gray2};
  :hover {
    color: ${(p) => p.theme.color.black1};
  }
  ${(p) =>
    p.isSelected &&
    `color: ${p.theme.color.black1}; font-weight: ${p.theme.fontWeight.semiBold}`}
`
